import z from "zod";

const pdfSchema = z.custom((val) => {
  return (
    val instanceof FileList &&
    val.length === 1 &&
    val[0].type === "application/pdf"
  );
});

const imgSchema = z.custom((val) => {
  return (
    val instanceof FileList && val.length === 1 && val[0].type === "image/jpeg"
  );
});

export const stencilSchema = z.object({
  id: z.string().min(2).max(30),
  name: z.string().min(2).max(100),
  category_id: z.number().min(0, { message: "ID must be a positive number." }),
  subcategory: z.string().max(100).optional(),
  pdf: pdfSchema,
  img: imgSchema,
  source: z.string().max(100).optional(),
});
